import siteMetadata from "@/data/siteMetadata"
import SocialIcon from "@/components/social-icons"

export default function Footer() {
	return (
		<footer className="box-border w-full px-4 sm:px-6">
			<div className="mx-auto mb-12 mt-10 flex w-full max-w-2xl flex-col items-center text-center">
				<div className="mb-4 flex justify-center text-blue-200">
					<SocialIcon kind="linkedin" href={siteMetadata.linkedin} size={6} />
				</div>
				<p className="text-balance text-sm leading-relaxed text-blue-200">
					<span className="whitespace-nowrap">2025</span>
					<span aria-hidden> · </span>
					Developed and maintained by {siteMetadata.author} in Kraków, Poland
				</p>
			</div>
		</footer>
	)
}
